<template>
  <aha-modal :title="$i18nPresenter.t('Access Request')" @hide="$emit('cancel')" :height="500">
    <div>
      <p class=" text-sm mb-4">
        {{ $i18nPresenter.t('To create and edit slides on your behalf, AhaSlides GPT will:') }}
      </p>
      <ul class="mb-4 ">
        <li class="flex items-center">
          <span class="text-green-600 text-sm mr-2">✅</span>
          <span class="font-bold">{{ $i18nPresenter.t('Access your profile') }}</span>
        </li>
        <li class="flex items-center">
          <span class="text-green-600 text-sm mr-2">✅</span>
          <span class="font-bold">{{ $i18nPresenter.t('View, create, and update your presentations') }}</span>
        </li>
        <li class="flex items-center">
          <span class="text-green-600 text-sm mr-2">✅</span>
          <span class="font-bold">{{ $i18nPresenter.t('Save your work securely to your account') }}</span>
        </li>
      </ul>
      <p class="text-gray-600 text-sm">
        {{ $i18nPresenter.t('We only access what is needed — your data stays private and in your control.') }}
      </p>
    </div>
    <template #action>
      <div class="flex justify-end gap-2">
        <aha-antd-button
          variant="secondary"
          v-aha-emit-action
          name="cancel - third - party - access"
          @click="$emit('cancel')"
        >
          {{ $i18nPresenter.t('Cancel') }}
        </aha-antd-button>

        <aha-antd-button v-aha-emit-action name="confirm-third-party-access" @click="$emit('confirm')">
          {{ $i18nPresenter.t('Allow') }}
        </aha-antd-button>
      </div>
    </template>
  </aha-modal>
</template>

<script>
export default {
  name: 'ProfileAccessConfirm',
  emits: ['confirm', 'cancel'],
}
</script>
